import Modal from "~/common/components/Modal";
import { ResponseTheme } from "~/providers/utils/types/patientPreviewTypes";
import { ResponseThemesTable } from "./ResponseThemesTable";

export const ResponseThemesModal = ({
  onClose,
  responseThemes,
  show,
}: {
  onClose: () => void;
  responseThemes: ResponseTheme[];
  show: boolean;
}) => (
  <Modal
    className="h-fit max-h-[80vh] w-auto overflow-y-auto sm:min-w-full md:min-w-[53rem]"
    titleClassName="text-2xl font-semibold w-2/3 text-gray-70"
    title="Response themes"
    show={show}
    onClose={onClose}
  >
    <div className="flex flex-col gap-4 text-gray-700">
      <p className="text-sm">
        This module is designed to flag and group patterns in patient-provided
        responses that may be useful for assessing clinical fit. It does not
        detect, diagnose, classify, or predict mental or emotional states. Any
        interpretation must be performed by a licensed clinician.
      </p>

      <ResponseThemesTable responseThemes={responseThemes} />
    </div>
  </Modal>
);
